/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Create_Team_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new team to organize your users and manage permissions." |
*
* @param {Teams_Create_Team_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_description = /** @type {((inputs?: Teams_Create_Team_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie ein neues Team, um Benutzer zu organisieren und Berechtigungen zu verwalten.")
	return /** @type {LocalizedString} */ ("Create a new team to organize your users and manage permissions.")
});